export default __webpack_public_path__ + "static/media/absence.db6dee9d.png";